//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio
// Creation Date : 11/02/2025
// Version : 1
// Description : editar caudal
//------Changes -------------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../services/apirest";
import {
  Container,
  Grid,
  Box,
  TextField,
  Button,
  InputAdornment,
  Dialog,
  DialogContent,
  Autocomplete,
} from "@mui/material";
import Notify from "../../Notify";
import Alerta from "../../Alerta";
import MessageIcon from "@mui/icons-material/Message";
import { logEventos } from "../../../services/services";
import Title from "../../Title";

function EditarModelosReg(props) {
  const [datosModelo, setDatosModelo] = useState(props.datos);
  const [disBtn, setDisBtn] = useState(false);
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [notificacion, setNotificacion] = useState(false); //define si se muestra o no una notificación (snackbar)
  const [error, setError] = useState(null); //guardará el error que lance la api (si existe)
  const [mensajeAlerta, setMensajeAlerta] = useState(""); //mensaje que contendrá el componente "alerta"
  const [finalizar, setFinalizar] = useState(); //finalizar === 1 lo manda como prop el componente "notify" e indica que la transaccion ha finalizado y debe ejecutarse la funcion para cerrar
  const [severityAlerta, setSeverityAlerta] = useState(""); //define severidad de la alerta (success error o warning)
  const [severitySnack, setSeveritySnack] = useState(""); //define severidad del snackbar (notificación)
  const [update, setUpdate] = useState(false);
  const [dialogEditar, setDialogEditar] = useState(props.dialogEditar);
  const [marca, setMarca] = useState([]);
  const [marcaSeleccionada, setMarcaSeleccionada] = useState("");

  const obtenerMarca = () => {
    fetch(UrlApi + "/reguladores_marcas/activos")
      .then((data) => data.json())
      .then((data) => setMarca(data));
  };
  useEffect(() => {
    obtenerMarca();
  }, []);

  useEffect(() => {
    setDatosModelo({
      ...props.datos,
    });
  }, [props.datos]);

  const handleClose = () => {
    setDialogEditar(!dialogEditar);
    if (props.onClose) {
      props.onClose();
    }
  };

  //Funcion para guardar
  const guardarEditar = async (e) => {
    logEventos(
      "Guardar edición del modelo",
      "Marcas y Modelos Reguladores",
      "Se guardo la edición del modelo",
      localStorage.getItem("user")
    );
    setDisBtn(true);
    e.preventDefault();
    const response = await fetch(
      UrlApi + "/reguladores_modelos/" + datosModelo.id_modelo,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          descripcion_modelos: datosModelo.descripcion_modelos,
          id_marca: marcaSeleccionada.id_marca,
          usuario: localStorage.getItem("user"),
        }),
      }
    );
    if (response.ok === false) {
      console.log("ERROR EN API");
      const error = response && response.json();
      setError(error);
      setSeverityAlerta("error");
      setMensajeAlerta("Inconvenientes con la API. No se pudo guardar. ");
    } else {
      console.log("Conexión con api OK");
      try {
        //Parseo respuesta de la api a json()
        const json = await response.json();
        //si api me devuelve lo q le puse en message
        if (json.message) {
          //Si ese mensaje es "OK"
          if (json.message === "OK") {
            console.log("Guardado Satisfactoriamente");
            setNotificacion(true);
            setOpenSnack(true);
            setColorMensaje("#D4EFDF");
            setMensaje("Guardado");
            setSeveritySnack("success");
          } else {
            console.log("res en api incorrecto. Revisar que sea 'OK'");
            setNotificacion(true);
            setOpenSnack(true);
            setColorMensaje("#D4EFDF");
            setSeveritySnack("error");
            setMensaje("Registro Guardado. REVISAR RESPUESTA DE API (E_S)");
          }
        } else if (json.sqlMessage) {
          json && setError(json);
          console.log(json);
          setMensajeAlerta(
            "SQL erróneo (" + json.code + " Errno: " + json.errno + " )"
          );
        } else {
          setMensajeAlerta("ERROR DESCONOCIDO.");
        }
      } catch (error) {
        if (error.toString().includes("is not valid JSON")) {
          console.log(
            "Guardado. Advertencia: Actualizar respuesta de api. JSON invalido."
          );
          setNotificacion(true);
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("Guardado");
          setSeveritySnack("success");
        } else {
          setMensajeAlerta("ERROR DESCONOCIDO.");
        }
      }
    }
    setUpdate(true);
    handleClose();
  };

  //funcion para almacenar
  const almacenar = (e) => {
    setDatosModelo({
      ...datosModelo,
      [e.target.name]: e.target.value === "" ? null : e.target.value,
    });
  };

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  const size = "small";
  return (
    <div>
      <br></br>
      <Dialog
        open={dialogEditar}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        color="#F4F6F6"
      >
        <Title
          titulo={`Editar Modelo`}
          handleClose={() => {
            handleClose();
          }}
        />

        <DialogContent>
          <Container maxWidth="xl">
            <form onSubmit={guardarEditar} autoComplete="off">
              <Grid container justifyContent="center" alignItems="center">
                <Grid item xs={12} sm={10} md={8} lg={6}>
                  <TextField
                    fullWidth
                    size={size}
                    margin="normal"
                    placeholder="..."
                    style={style}
                    //  focused
                    color="primary"
                    required
                    name="descripcion_modelos"
                    label="Descripción modelo"
                    variant="outlined"
                    value={datosModelo.descripcion_modelos}
                    inputProps={{
                      maxLength: 60,
                    }}
                    onChange={almacenar}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <MessageIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                {marca && (
                  <Grid item xs={12} md={8} mt={1}>
                    <Autocomplete
                      style={style}
                      disableClearable
                      size="small"
                      //  focused={true}
                      required
                      id="id_marca"
                      noOptionsText={"Marca INEXISTENTE"}
                      options={marca}
                      autoHighlight
                      getOptionLabel={(marca) => marca.descripcion_marca}
                      onChange={(event, value) => setMarcaSeleccionada(value)}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          key={option.id_marca}
                          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                          {...props}
                        >
                          {option.descripcion_marca}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          inputProps={{
                            ...params.inputProps,
                            style: { width: "100%" }, // Ajusta el ancho del TextField al 100% del contenedor
                          }}
                          //     focused
                          size="small"
                          placeholder="Tipee para buscar la marca..."
                          label="Cambiar de marca "
                        />
                      )}
                    />
                  </Grid>
                )}
              </Grid>
              <Grid
                container
                justifyContent="space-between"
                alignItems="flex-end"
                mt={2}
              >
                <Button variant="contained" onClick={handleClose} color="error">
                  Volver
                </Button>

                <Button
                  disabled={disBtn}
                  variant="contained"
                  type="submit"
                  color="success"
                >
                  Guardar Edición
                </Button>
              </Grid>
            </form>
          </Container>
        </DialogContent>
      </Dialog>
      {notificacion ? (
        <Notify
          mensaje={mensaje}
          open={openSnack}
          color={colormensaje}
          finalizar={setFinalizar}
          severity={severitySnack}
        />
      ) : null}
      {/* ALERT --> SE MUESTRA SI HAY UN ERROR EN LA API (NO SE CONECTA O ESTÁ MAL LA RUTA, ETC.) */}
      {error && mensajeAlerta ? (
        <Alerta mensaje={mensajeAlerta} severity={severityAlerta} />
      ) : null}
    </div>
  );
}

export default EditarModelosReg;
